<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">{{ title }}</h4>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
          <div class="col-md-12">
            <fg-input type="text"
                      label="Frage"
                      placeholder="Frage eingeben"
                      v-model="question.question">
            </fg-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label>Typ</label>
            <select name="type" id="type"
                    v-model="question.type"
                    class="form-control">
              <option value="NUMBER">Zahl</option>
              <option value="TEAM">Team</option>
              <option value="BOOL">Ja/Nein</option>
            </select>
          </div>
          <div class="col-md-3">
            <fg-input
                      label="Anzahl Antworten"
                      v-model="answer_count">
            </fg-input>
          </div>
          <div class="col-md-3">
            <fg-input
              label="Punkte pro Antwort"
              v-model="points">
            </fg-input>
          </div>
        </div>
        <!--
        <div class="row">
          <div class="col-md-12">
            <fg-input type="text"
                      label="Antwort"
                      placeholder="Antwort"
                      v-model="question.answer">
            </fg-input>
          </div>
        </div>
        -->
        <div class="row">
          <div class="col-md-12">
            <label style="margin-right: 10px;">Antwort abgeben bis</label>
            <el-date-picker
              v-model="question.editable_until"
              type="datetime"
              format="dd.MM.yyyy HH:mm"
              placeholder="Select date and time">
            </el-date-picker>
          </div>
        </div>

        <div class="row" style="margin-top: 30px; margin-bottom: 30px;">
          <div class="col-md-3">

          <label v-if="question.answer_count === 1" style="margin-top: 10px;">Lösung eingeben</label>
          <label v-else-if="question.answer_count > 1" style="margin-top: 10px;">Lösungen eingeben</label>
          </div>

          <div class="col-md-9">
          <multiselect @input="multiChanged" v-if="question.answer_count > 1 && question.type === 'TEAM'" v-model="values" :options="options" :multiple="true" :max="question.answer_count" :show-labels="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Bitte wählen" label="name" track-by="id" :preselect-first="false">
          </multiselect>

          <multiselect @input="singleChanged" v-else-if="question.answer_count === 1 && question.type === 'NUMBER'" v-model="value" :options="optionsNumber" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Bitte wählen"></multiselect>

          <multiselect @input="singleChanged" v-else-if="question.answer_count === 1 && question.type === 'BOOL'" v-model="value" :options="optionsBool" track-by="name" label="name" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Bitte wählen">
            <template slot="singleLabel" slot-scope="{ option }">
              <span v-if="option.val === 1">Ja</span>
              <span v-else-if="option.val === 0">Nein</span>
              <span v-else></span>
            </template>
          </multiselect>

          <multiselect @input="singleChanged" v-else-if="question.answer_count === 1 && question.type === 'TEAM'" v-model="value" deselect-label="Can't remove this value" track-by="id" label="name" :show-labels="false" placeholder="Bitte wählen" :options="options" :searchable="false" :allow-empty="true">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
          </multiselect>
          </div>
        </div>


        <div class="row">
          <div class="col-md-12" style="margin-top: 30px; padding-bottom: 20px;">
            <div class="text-right">
              <button type="submit" class="btn btn-fill btn-wd" @click.prevent="updateQuestion">
                Speichern
              </button>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>

      </form>

      <div class="row">
        <div v-if="question.id > 0" class="col-md-12" style="padding-bottom: 20px;">
          <div class="text-right">
            <button type="button" class="btn btn-fill btn-wd" @click.prevent="deleteQuestion">
              Sonderfrage löschen
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import {DatePicker, TimeSelect} from 'element-ui'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import moment from 'moment'
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect
    },
    props: {
      id: {
        type: Number,
        default: () => {
          return 0
        }
      }
    },
    data () {
      return {
        value: null,
        values: [],
        solutionSaved: false,
        points: '10',
        answer_count: '1',
        new_question: {
          id: 0,
          fk_betgame: this.$store.state.betgame,
          question: '',
          answer: '',
          type: 'NUMBER',
          points: '0',
          answer_count: '1',
          editable_until: null
        }
      }
    },
    created () {
      this.points = '' + (this.question.points !== undefined ? this.question.points : 1)
      this.answer_count = '' + (this.question.answer_count !== undefined ? this.question.answer_count : 1)
      const solutions = this.$store.state.solutions.filter(s => s.fk_question === this.question.id)
      if (this.question.answer_count === 1) {
        if (this.question.type === 'NUMBER' && solutions[0]) {
          this.value = parseInt(solutions[0].solution)
        } else if (this.question.type === 'TEAM' && solutions[0]) {
          this.value = this.question.optionsJSON.filter(s => s.id === parseInt(solutions[0].solution))[0]
        } else if (this.question.type === 'BOOL' && solutions[0]) {
          if (parseInt(solutions[0].solution) === 0) {
            this.value = { name: 'Nein', val: 0 }
          } else if (parseInt(solutions[0].solution) === 1) {
            this.value = { name: 'Ja', val: 1 }
          }
        } else {
          this.value = null
        }
      } else if (this.question.answer_count > 1) {
        var temp = []
        for (var i = 0; i < solutions.length; i++) {
          const val = solutions[i]
          const v = this.question.optionsJSON.filter(s => s.id === parseInt(val.solution))[0]
          temp.push(v)
        }
        this.values = temp
      }
    },
    computed: {
      title () {
        if (this.id === 0) {
          return 'Hinzufügen'
        }
        return 'Bearbeiten'
      },
      question () {
        if (this.id === 0) {
          return this.new_question
        }
        const questions = this.$store.getters.getQuestionById(this.id)
        if (questions.length > 0) {
          return questions[0]
        }
        return {}
      },
      options () {
        return this.question.optionsJSON !== undefined && this.question.optionsJSON !== null ? this.question.optionsJSON : []
      },
      optionsBool () {
        return [
          { name: 'Ja', val: 1 },
          { name: 'Nein', val: 0 }
        ]
      },
      optionsNumber () {
        const o = this.question.options
        const minmax = o.trim().split(',')
        if (minmax.length === 2) {
          const min = minmax[0] < minmax[1] ? minmax[0] : minmax[1]
          const max = minmax[0] < minmax[1] ? minmax[1] : minmax[0]
          var result = [max - min]
          if (min !== max) {
            for (var i = min, c = 0; i <= max; i++, c++) {
              result[c] = i
            }
          }
          return result
        }
        return []
      }
    },
    methods: {
      multiChanged () {
        if (this.values.length !== this.question.answer_count) {
          return
        }
        var solutions = []
        for (var i = 0; i < this.values.length; i++) {
          const val = this.values[i]
          solutions.push({
            'fk_question': this.question.id,
            'solution': parseInt(val.id)
          })
        }
        this.$store.dispatch('updateSolution', solutions).then(response => {
          this.$log.debug('Solution multiChanged updateSolution ok')
          this.answerSaved = true
          this.log.debug('special_questions.solutions_saved')
        }, error => {
          this.$log.debug(error.toString())
        })
      },
      singleChanged () {
        var s = this.value.id
        if (this.question.type === 'NUMBER') {
          s = this.value
        } else if (this.question.type === 'BOOL') {
          s = this.value.val
        }
        const solution = {
          'fk_question': this.question.id,
          'solution': parseInt(s)
        }
        this.$log.debug('Solution singleChanged ' + JSON.stringify(solution))
        this.$store.dispatch('updateSolution', solution).then(response => {
          this.$log.debug('Solution singleChanged updateSolution ok')
          this.solutionSaved = true
          // this.$toast.open({ message: this.$i18n.t('special_questions.solution_saved'), position: 'top', duration: TOAST_DURATION, type: 'success' })
        }, error => {
          this.$log.debug(error.toString())
        })
      },
      deleteQuestion () {
        if (this.question.id > 0) {
          var r = confirm('Sonderfrage löschen?')
          if (r === true) {
            this.$store.dispatch('deleteQuestion', this.question.id).then(response => {
              this.$router.push('/questions')
            }, error => {
              this.$log.debug(error)
            })
          }
        }
      },
      updateQuestion () {
        var valid = true
        if (this.isNullOrUndefined(this.question.question) || this.question.question.length === 0) {
          valid = false
        }
        if (this.isNullOrUndefined(this.points) || this.points < 1) {
          valid = false
        }
        if (this.isNullOrUndefined(this.answer_count) || this.answer_count < 1) {
          valid = false
        }
        var options = this.question.options
        if (this.question.type === 'NUMBER') {
          options = '0,100'
        } else if (this.question.type === 'TEAM') {
          const teams = this.$store.state.competitionTeams
          var result = []
          if (teams.length > 0) {
            for (var i = 0; i < teams.length; i++) {
              const team = teams[i].bg_team
              result.push({id: team.id, name: team.name})
            }
          }
          options = JSON.stringify(result)
        } else if (this.question.type === 'BOOL') {
          options = '0,1'
        }
        if (this.question.id === 0) {
          if (valid) {
            const insertquestion = {
              'question': this.question.question,
              'type': this.question.type,
              'points': parseInt(this.points),
              'answer_count': parseInt(this.answer_count),
              'fk_betgame': parseInt(this.$store.state.betgame),
              'fk_season': parseInt(this.$store.state.currentSeason.id),
              'editable_until': moment(this.question.editable_until).format('YYYY-MM-DD HH:mm:ss'),
              'options': options
            }
            this.$store.dispatch('postQuestion', insertquestion).then(response => {
              this.question.id = response
              alert('Die Sonderfrage wurde gespeichert.')
            }, error => {
              this.$log.debug(error)
            })
          } else {
            alert('Die Sonderfrage konnte nicht hinzugefügt werden.')
          }
        } else {
          const updatequestion = {
            'id': this.question.id,
            'question': this.question.question,
            'type': this.question.type,
            'points': parseInt(this.points),
            'answer_count': parseInt(this.answer_count),
            'fk_betgame': parseInt(this.$store.state.betgame),
            'fk_season': parseInt(this.$store.state.currentSeason.id),
            'editable_until': moment(this.question.editable_until).format('YYYY-MM-DD HH:mm:ss'),
            'options': options
          }
          this.$store.dispatch('patchQuestion', updatequestion).then(response => {
            alert('Die Sonderfrage wurde gespeichert.')
          }, error => {
            this.$log.debug(error)
          })
        }
      },
      isNullOrUndefined (data) {
        return data === null || data === undefined
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGEditQuestionForm.vue